//
// Copyright (c) 2011-2024 by Curalate, Inc.
//

import React, { ReactNode } from 'react';
import { useTheme } from 'styled-components';

import LoadingShimmer from '@components/atoms/loading-shimmer/LoadingShimmer';
import Text from '@components/atoms/text/Text';
import { Mixins } from '@theme/mixins';
import { pluralize } from '@utils/stringUtils';

interface MediaLibraryItemsSummaryProps {
  isLoading: boolean;
  itemCount: number | undefined;
  showSummaryToggle?: ReactNode;
}

export const ItemsSummary = ({
  isLoading,
  itemCount,
  showSummaryToggle,
}: MediaLibraryItemsSummaryProps) => {
  const theme = useTheme();

  return isLoading ? (
    <LoadingShimmer height={theme.spacings[2]} width='120px' />
  ) : (
    <>
      <Text mixin={Mixins.Text.BodyDisabled}>
        {pluralize(itemCount ?? 0, 'Item')}
      </Text>
      {showSummaryToggle}
    </>
  );
};
